import React, { useMemo } from 'react';
import { BeveledPanel } from '../Equipment/FabProcessTool/BeveledPanel';
import { getStockerMaterials } from './StockerMaterials';
import type { StockerDimensions, StockerStatus } from './stockerTypes';

export type StockerLightsProps = {
  dims: StockerDimensions;
  status?: StockerStatus;
  opacity?: number;
};

const STATUS_INTENSITY: Record<StockerStatus, number> = {
  ready: 0.75,
  running: 1,
  warning: 0.85,
  error: 0.9,
  offline: 0.35,
};

/** Internal neutral LED strips + top cap accent. */
export const StockerLights: React.FC<StockerLightsProps> = ({
  dims,
  status = 'ready',
  opacity = 1,
}) => {
  const mats = useMemo(() => getStockerMaterials(opacity), [opacity]);
  const { width, height, depth, glassY, frontZ } = dims;
  const intensity = STATUS_INTENSITY[status] * opacity;

  return (
    <group name="StockerLights">
      <BeveledPanel
        size={[width * 0.55, height * 0.008, depth * 0.015]}
        material={mats.cyanLed}
        position={[0, height * 0.94, frontZ + depth * 0.02]}
      />
      <pointLight
        position={[0, glassY, depth * 0.06]}
        intensity={0.68 * intensity}
        color="#F8FAFC"
        distance={width * 1.55}
      />
      <pointLight
        position={[0, height * 0.72, -depth * 0.1]}
        intensity={0.32 * intensity}
        color="#FFFFFF"
        distance={width * 1.15}
      />
    </group>
  );
};

export default StockerLights;
